import { FiMessageSquare, FiPlay, FiUpload } from 'react-icons/fi';
import {
  CompactQuickActionButton,
  CompactQuickActions,
} from '../../WorkspaceHeaderLayout.styles';

type Props = {
  onAsk: () => void;
  onUpload: () => void;
  onRunTask: () => void;
};

export const WorkspaceHeaderCompactQuickActions: React.FC<Props> = ({
  onAsk,
  onUpload,
  onRunTask,
}) => (
  <CompactQuickActions aria-label="Workspace quick actions">
    <CompactQuickActionButton type="button" onClick={onAsk} title="Open Ask">
      <FiMessageSquare size={14} />
      Ask
    </CompactQuickActionButton>
    <CompactQuickActionButton type="button" onClick={onUpload} title="Upload document">
      <FiUpload size={14} />
      Upload
    </CompactQuickActionButton>
    <CompactQuickActionButton type="button" onClick={onRunTask} title="Open prompts">
      <FiPlay size={14} />
      Task
    </CompactQuickActionButton>
  </CompactQuickActions>
);
